/**
 * File: common.js.
 *
 * Import and initialize functions that are common to all pages
 */

// import elements here
import forms from '../elements/forms';
import carousel from '../elements/carousel';
import progressBar from '../elements/progressBar';
import card from '../elements/card';

// import modules here
import navigation from '../modules/navigation';
import hero from '../modules/hero';
import newsletter from '../modules/newsletter';
import filter from '../modules/filter';
import wpBlockColumns from '../elements/wpBlockColumns';

export default {
  wpColumns: document.querySelectorAll('.wp-block-columns'),
  init() {
    this.render();
  },
  render() {
    // elements
    forms.init();
    card.init();
    carousel.init();
    wpBlockColumns.init();

    // modules
    navigation.init();
    progressBar.init();
    hero.init();
    newsletter.init();
    filter.init();
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
